import { render, staticRenderFns } from "./EfsStdCompanyStandardForm.vue?vue&type=template&id=72f44c1d&scoped=true&"
import script from "./EfsStdCompanyStandardForm.vue?vue&type=script&lang=js&"
export * from "./EfsStdCompanyStandardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f44c1d",
  null
  
)

export default component.exports